import type { TermsContent } from "@/types/privacy";

const termsContent: TermsContent = {
  "title": "AptFleet Terms and Conditions",
  "effectiveDate": "14 Feb 2025",
  "introduction": "These Terms and Conditions (\"Terms\") govern the use of AptFleet (\"Service\"), a business-to-business (B2B) software-as-a-service (SaaS) platform provided by Twinhelix Services Ltd (\"Company,\" \"we,\" \"us,\" or \"our\") to business customers (\"Customer,\" \"you,\" or \"your\"). By accessing or using AptFleet, you agree to be bound by these Terms.",
  "sections": [
    {
      "id": "definitions",
      "title": "1. Definitions",
      "content": [
        "\"Service\" refers to the AptFleet platform and any related services provided by the Company.",
        "\"Customer\" refers to any business entity that has entered into an agreement with the Company to use the Service.",
        "\"User\" means any individual authorised by the Customer to access and use the Service.",
        "\"Agreement\" refers to these Terms and any additional written agreements executed by the parties."
      ]
    },
    {
      "id": "eligibility",
      "title": "2. Eligibility",
      "content": [
        "The Service is available exclusively to business customers. By using the Service, you represent and warrant that you are a duly organised business entity with the legal capacity to enter into these Terms.",
        "Individuals accessing the Service on behalf of a business represent that they have the authority to bind their organisation to these Terms."
      ]
    },
    {
      "id": "account-registration",
      "title": "3. Account Registration and Security",
      "content": [
        "Customers must register for an account to access the Service. All information provided during registration must be accurate and current.",
        "You are responsible for safeguarding your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorised use of your account or any other breach of security."
      ]
    },
    {
      "id": "service-use",
      "title": "4. Use of the Service",
      "content": [
        "The Service is provided solely for the Customer's internal business operations and must not be used for any illegal, fraudulent, or unauthorised purposes.",
        "Customers agree to comply with all applicable laws and regulations in connection with their use of the Service."
      ]
    },
    {
      "id": "payments",
      "title": "5. Payment and Fees",
      "content": [
        "Access to the Service is provided on a subscription basis, and fees will be billed in accordance with the selected subscription plan.",
        "All fees are non-refundable unless otherwise expressly stated. Late payments may result in suspension or termination of access to the Service."
      ]
    },
    {
      "id": "term-termination",
      "title": "6. Term and Termination",
      "content": [
        "These Terms commence on the Effective Date and continue until terminated by either party in accordance with this section.",
        "Either party may terminate the Agreement with written notice if the other party breaches any material term of these Terms and fails to remedy such breach within thirty (30) days of receiving notice."
      ]
    },
    {
      "id": "intellectual-property",
      "title": "7. Intellectual Property",
      "content": [
        "All intellectual property rights in the Service and its underlying technology are owned by the Company or its licensors.",
        "No rights are granted to the Customer except as expressly set forth in these Terms."
      ]
    },
    {
      "id": "confidentiality",
      "title": "8. Confidentiality",
      "content": [
        "Both parties agree to maintain the confidentiality of any proprietary or confidential information disclosed during the term of this Agreement.",
        "This obligation continues for a period of two (2) years after termination of the Agreement."
      ]
    },
    {
      "id": "warranty-disclaimer",
      "title": "9. Warranty and Disclaimer",
      "content": [
        "The Company warrants that the Service will perform substantially in accordance with its published documentation.",
        "EXCEPT AS EXPRESSLY PROVIDED IN THIS AGREEMENT, THE SERVICE IS PROVIDED ON AN \"AS IS\" BASIS, AND THE COMPANY DISCLAIMS ALL WARRANTIES, WHETHER EXPRESS, IMPLIED, OR STATUTORY, INCLUDING, WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT."
      ]
    },
    {
      "id": "limitation-of-liability",
      "title": "10. Limitation of Liability",
      "content": [
        "IN NO EVENT SHALL THE COMPANY BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF OR IN CONNECTION WITH THIS AGREEMENT.",
        "THE COMPANY'S AGGREGATE LIABILITY ARISING OUT OF OR RELATED TO THIS AGREEMENT SHALL NOT EXCEED THE TOTAL AMOUNT PAID BY THE CUSTOMER FOR THE SERVICE IN THE TWELVE (12) MONTHS PRECEDING THE CLAIM."
      ]
    },
    {
      "id": "indemnification",
      "title": "11. Indemnification",
      "content": [
        "The Customer agrees to indemnify, defend, and hold harmless the Company and its officers, directors, employees, and agents from any claims, damages, liabilities, costs, and expenses arising from the Customer's use of the Service or any breach of these Terms."
      ]
    },
    {
      "id": "governing-law",
      "title": "12. Governing Law and Dispute Resolution",
      "content": [
        "These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which the Company is established, without regard to its conflict of law provisions.",
        "Any disputes arising out of or relating to these Terms shall be resolved through negotiation in good faith. If a resolution cannot be reached, the dispute will be submitted to binding arbitration in accordance with the rules of the applicable arbitration body."
      ]
    },
    {
      "id": "modifications",
      "title": "13. Modifications to Terms",
      "content": [
        "The Company reserves the right to modify or update these Terms at any time. Notice of any changes will be provided via email or through the Service.",
        "Continued use of the Service after such notice constitutes acceptance of the modified Terms."
      ]
    },
    {
      "id": "contact-information",
      "title": "14. Contact Information",
      "content": [
        "If you have any questions regarding these Terms or the Service, please contact us at:",
        "Email: support@aptfleet.com",
        
      ]
    }
  ],
  contactInfo: "For any questions regarding these Terms..."
}

export default termsContent;